module.exports = __webpack_public_path__ + "static/img/12.c5c13d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/sp/12.png
// module id = evZY
// module chunks = 0